import { MCP_SPECIFICATION } from "@app/lib/actions/utils_ui";
import type { DataSourceViewCategory } from "@app/types/api/public/spaces";
import type { WhitelistableFeature } from "@app/types/shared/feature_flags";
import type { EnrichedSpaceType } from "@app/types/space";
import {
  AzimutRegion,
  AzimutRestrictedRegion,
  AzimutCollaboration,
  AzimutRestrictedCollaboration,
  AzimutConnections,
  Folder,
  Globe01,
  Terminal,
  Zap,
} from "@dust-tt/sparkle";
import type React from "react";

export type { SpaceSectionGroupType } from "@app/lib/spaces_utils";
// Re-export non-UI utilities for backward compatibility.
export {
  dustAppsListUrl,
  getSpaceName,
  groupSpacesForDisplay,
  isPrivateSpacesLimitReached,
} from "@app/lib/spaces_utils";

export function getSpaceIcon(
  space: EnrichedSpaceType
): (props: React.SVGProps<SVGSVGElement>) => React.ReactElement {
  if (space.kind === "project") {
    return space.isRestricted
      ? AzimutRestrictedCollaboration
      : AzimutCollaboration;
  }

  if (space.isRestricted) {
    return AzimutRestrictedRegion;
  }

  return AzimutRegion;
}

export const CATEGORY_DETAILS: {
  [key in DataSourceViewCategory]: {
    icon: React.ComponentType<{
      className?: string;
    }>;
    flag?: WhitelistableFeature;
  };
} = {
  managed: {
    icon: AzimutConnections,
  },
  folder: {
    icon: Folder,
  },
  website: {
    icon: Globe01,
  },
  apps: {
    icon: Terminal,
    flag: "legacy_dust_apps",
  },
  actions: {
    icon: MCP_SPECIFICATION.cardIcon,
  },
  triggers: {
    icon: Zap,
  },
};
